import {
  Button,
  Card,
  FlexBox,
  TextField,
  Spinner,
} from '@cimpress/react-components';
import React, {ReactElement, useEffect, useState} from 'react';
import {ModalAlert} from '../../types/modal-alert';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {button} from '../../types/button-styles';
import { getFileNameTestResult } from '../../clients/VLRAClient';

function VLRAFilenameTester({showAlert, tenant, defaultFilename}: { showAlert: (alert: ModalAlert) => void, tenant?: string, defaultFilename?: string }): ReactElement {
  const [isLoading, setIsLoading] = useState(false);
  const [vlraFilename, setVlraFilename] = useState(defaultFilename ?? '');

  useEffect(() => {
    setVlraFilename(defaultFilename ?? '');
  }, [defaultFilename]);

  const testVLRAFilename = () => {
    setIsLoading(true);
    getFileNameTestResult(vlraFilename, tenant)
      .then(response => {
        showAlert({
          message: <div>{response}</div>,
          title: 'Response From VLRA',
          type: 'info'
        });
      }).catch(e => {
      console.error(e);
      showAlert({
        message: e.message,
        title: 'Received an Error from the VLRA',
        type: 'danger'
      });
    }).finally(() => {
      setVlraFilename(defaultFilename ?? '');
      setIsLoading(false);
    });
  };

  const submitButton = <Button
      className={button}
      onClick={() => testVLRAFilename()}
    >
        <FontAwesomeIcon icon="file" /> Test Filename
    </Button>;
  const filenameField = <TextField placeholder="Filename" onChange={c => setVlraFilename(c.target.value)}
                       value={vlraFilename}
                       rightAddon={submitButton} />;

  return (
    <>
      {isLoading &&
      <FlexBox justifyContent="center">
        <Spinner size="medium"/>
      </FlexBox>
      }
      <Card header="Test Viper Log Reader Adapter Filename">
        <div className="container">
          <div>
            {filenameField}
          </div>
        </div>
      </Card>
    </>
  );
}

export default VLRAFilenameTester;
